<script>
export default {
    name: "MinimizedDescription",
    props: {
        maxHeight: {
            type: String,
        },
    },
    data() {
        return {
            isMinimizedDescription: true,
        };
    },
};
</script>

<template>
    <div class="minimized-description">
        <div class="minimized-description__content minimized-description__content--nowrap">
            <slot name="no-wrap"></slot>
        </div>
        <div
            class="minimized-description__content"
            :style="{ 'max-height': maxHeight ? maxHeight + 'px' : '44px' }"
            :class="{ is_minimize: !isMinimizedDescription }">
            <slot></slot>
        </div>
        <div class="minimized-description__minimize color-accent">
            <div @click="isMinimizedDescription = !isMinimizedDescription">
                {{ isMinimizedDescription ? "подробнее" : "свернуть" }}
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
.minimized-description {
    margin-bottom: 19px;
    .is_minimize {
        max-height: 500px !important;
    }
    &__content {
        transition: max-height 0.2s;
        font-weight: 400;
        line-height: 21.6px;
        letter-spacing: 0.16em;
        text-align: left;
        max-height: 44px;
        overflow: hidden;
        white-space: normal;
        position: relative;
        @media @sm {
            gap: 10px 25px;
            align-items: center;
            font-size: 11px;
            line-height: 16.5px;
            max-height: 80px;
            overflow: hidden;
            margin-bottom: 10px;
            margin-top: 24px;
        }

        &--nowrap {
            max-height: unset;
            overflow: unset;
        }
    }

    &__minimize {
        margin-top: 16px;
        cursor: pointer;
        line-height: 11px;
        letter-spacing: 0.16em;
        border-bottom: 1px solid;
        display: inline-block;
    }
}
</style>
